import { agentHubOrSubBrandConfig } from 'agentHub/constants'

export const LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP = `/${agentHubOrSubBrandConfig.basePath}/complete-account-setup`
